import { Schema } from "effect";

import { Email, Password } from "../shared/fields";

export const SignInInput = Schema.Struct({
  email: Email,
  password: Password,
});
export type SignInInput = typeof SignInInput.Type;

export const SignUpInput = Schema.Struct({
  name: Schema.String.pipe(
    Schema.check(
      Schema.isMinLength(1, {
        message: "Name is required",
      })
    )
  ),
  email: Email,
  password: Password,
});
export type SignUpInput = typeof SignUpInput.Type;
